import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
  adjustAssigneeCounts({ state: $state, commit }, data) {
    const { previousAssignee, nextAssignee, currentUserId } = data;
    const previousAssigneeId = previousAssignee?.id
      ? String(previousAssignee.id)
      : null;
    const nextAssigneeId = nextAssignee?.id ? String(nextAssignee.id) : null;
    const currentUserIdString = currentUserId ? String(currentUserId) : null;

    if (previousAssigneeId === nextAssigneeId) return;

    const wasUnassigned = !previousAssigneeId;
    const isUnassigned = !nextAssigneeId;
    const wasMine = previousAssigneeId === currentUserIdString;
    const isMine = nextAssigneeId === currentUserIdString;

    commit(types.SET_CONV_TAB_META, {
      mine_count: Math.max(
        $state.mineCount + (isMine ? 1 : 0) - (wasMine ? 1 : 0),
        0
      ),
      unassigned_count: Math.max(
        $state.unAssignedCount +
          (isUnassigned ? 1 : 0) -
          (wasUnassigned ? 1 : 0),
        0
      ),
      all_count: $state.allCount,
      deleted_count: $state.deletedCount,
    });
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
